
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/smart-chains/tutorials/multisignature-transaction-creation-and-walkthrough",
      function () {
        return require("private-next-pages/docs/smart-chains/tutorials/multisignature-transaction-creation-and-walkthrough/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/smart-chains/tutorials/multisignature-transaction-creation-and-walkthrough"])
      });
    }
  